export const onboardingEvents = {
  ENTERED_PINCODE:"entered_pincode",
  SELECTED_SCHOOL: "selected_school",
  ONBOARD_FORM_SUBMITTED:"onboard_form_submitted",
  SIGN_UP_SUCCESSFUL:"sign_up_successful",
  SIGNED_IN:"signed_in"
};

export const sessionEvents = {
    VIEWED_DASHBOARD : "viewed_dashboard",

    STARTED_BUILDING_PRACTICE : "started_building_practice",
    UPDATED_PRACTICE_QUESTIONS : "updated_practice_questions",
    CANCELLED_PRACTICE_CREATION : "cancelled_practice_creation",
    VIEWED_PRACTICE:"viewed_practice",
    ASSIGNED_PRACTICE: "assigned_practice"
}
export const questionEvents = {
  REPORT_QUESTION:"reported_question"
}
export const inviteEvents = {
  CLICKED_ON_INVITE_STUDENT:"clicked_on_invite_student",
  INVITED_STUDENT:"invited_student"
}
export const questionBuilderEvents = {
  CLICKED_ON_ADD_QUESTION:"CLICKED_ON_ADD_QUESTION",
  BUILT_QUESTION_BODY:"BUILT_QUESTION_BODY",
  ADDED_QUESTION_META:"ADDED_QUESTION_META",
  SAVED_QUESTION:"SAVED_QUESTION",
  CANCELLED_QUESTION_BUILDING:"CANCELLED_QUESTION_BUILDING"
}